import i18n from "i18next";
import { initReactI18next } from "react-i18next";
// ✅ Fonction pour récupérer la langue à partir de l'URL
const getLanguageFromURL = () => {
  const pathSegments = window.location.pathname.split("/"); // Découpe l'URL en segments
  const possibleLang = pathSegments[1]; // Récupère la première partie après "/"

  // Vérifie si la langue détectée est bien une des langues supportées
  const supportedLanguages = ["fr", "en", "de"];
  return supportedLanguages.includes(possibleLang)
    ? possibleLang
    : i18n.language;
};

const currentLang = getLanguageFromURL(); // Récupère la langue à partir de l'URL

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: {
        helmet: {
          home: {
            title: "Home - Race Motors Group",
            description: "Discover our luxury cars in Switzerland.",
          },
          contact: {
            title: "Contact Us - Race Motors Group",
            description:
              "Get in touch with Race Motors Group for any inquiries or information about our luxury cars.",
          },
          cars: {
            title: "Our Cars - Race Motors Group",
            description:
              "Explore our exclusive collection of luxury cars and find your dream vehicle today.",
          },
          carDetails: {
            metaDescription:
              "Explore the details of {{carTitle}}, including specifications, gallery, and brochure.",
          },
        },
        menu: {
          home: "Home",
          vehicles: "Our Vehicles",
          contact: "Contact",
          cars: "Cars",
        },
        footer: {
          contactEmail: "contact@rmg.com",
          copyrightName: "Race Motors Group",
          copyright: "All rights reserved",
          legal: "LEGAL NOTICE",
          privacy: "PRIVACY POLICY",
          siteBy: "SITE BY V.MARCONNET",
        },
        videoCarousel: {
          videos: [
            {
              title: "HOLIDAY SEASON",
              subject: "Collections",
              discoverText: "Discover gifts",
            },
            {
              title: "LIMITED EDITION",
              subject: "Exclusivity",
              discoverText: "Discover the limited edition available now",
            },
            {
              title: "NEW ARRIVAL",
              subject: "New Arrivals",
              discoverText: "Discover the latest arrivals",
            },
          ],
        },
        cars: {
          title: "Our Cars",
          description: "Browse through our exclusive car collection.",
          year: "Year",
          power: "Power",
          price: "Price",
          noCars: "No cars found. Please try again later.",
        },
        carDetails: {
          notFound: "Car not found!",
          back: "Back",
          price: "Price",
          year: "Year",
          power: "Power",
          specification: "Specification",
          details: "Details",
          driveType: "Drive Type",
          engine: "Engine",
          transmission: "Transmission",
          maxTorque: "Max Torque",
          topSpeed: "Top Speed",
          acceleration: "Acceleration",
          exteriorColor: "Exterior Color",
          interiorColor: "Interior Color",
          photoGallery: "Photo Gallery",
          video: "Video",
          carSoundImmersion: "Plongez dans l'expérience sonore !",
          carSoundTip:
            "Mettez vos écouteurs et ressentez la puissance de ce moteur.",
          discoverButton: "Discover",
          interestButton: "Interested ?",
        },
        instagram: {
          followUs: "FOLLOW US ON",
        },
        contactForm: {
          title: "Contact us",
          name: "Name",
          namePlaceholder: "Your name",
          email: "Email",
          emailPlaceholder: "Your email",
          message: "Message",
          messagePlaceholder: "Your message",
          submit: "Send",
          emailSuccess: "Email sent successfully!",
          emailError: "Error sending email!",
          gender: {
            male: "Mr.",
            female: "Mrs.",
          },
          firstName: "First Name",
          firstNamePlaceholder: "Your first name",
          lastName: "Last Name",
          lastNamePlaceholder: "Your last name",
          region: "Region",
          regionPlaceholder: "Your region",
        },
        showroom: {
          subTitle: "Race Motors Group / OUR VEHICLES",
          title: "THE RACE MOTORS GROUP SHOWROOM",
          description1:
            "Discover a space dedicated to luxury, sports, and exceptional cars, located about thirty minutes from Geneva.",
          description2:
            "Our sales team welcomes you exclusively by appointment in our showroom to present a selection of exceptional vehicles and answer all your requests with professionalism.",
          button: "SHOWROOM →",
        },
        services: {
          title: "RMG SERVICES",
          description:
            "All the cars in our collection are carefully selected. History, warranty, and configuration – we leave nothing to chance to give you access to the elite. This same requirement applies to our entire range of complementary services. From personalized search to delivery by our team, including concierge services, we do everything to make your dream come true in the best possible conditions.",
          button: "FIND OUT MORE →",
          imageAlt: "Luxury Cars",
        },
        servicesSection: {
          saleTitle: "SALE",
          saleDescription: "Vehicles available in the showroom.",
          searchTitle: "SEARCH",
          searchDescription: "Let's find your dream car together.",
          exceptionTitle: "EXCEPTION",
          exceptionDescription:
            "Rare 'off-market' vehicles in exclusive access.",
        },
        banner: {
          text: "FOR SECURITY, <span class='bold'>CONFIDENTIALITY</span> & SERVICE QUALITY REASONS, <span class='bold highlight'>OUR TEAM WELCOMES YOU BY APPOINTMENT ONLY.</span>",
          contact: "CONTACT US →",
        },
        newArrival: {
          title: "NEW ARRIVALS",
          subtitle: "DISCOVER THE LATEST ADDITIONS TO OUR COLLECTION",
        },
      },
    },
    fr: {
      translation: {
        helmet: {
          home: {
            title: "Accueil - Race Motors Group",
            description: "Découvrez nos voitures de luxe en Suisse.",
          },
          contact: {
            title: "Contactez-nous - Race Motors Group",
            description:
              "Contactez Race Motors Group pour toute question ou information concernant nos voitures de luxe.",
          },
          cars: {
            title: "Nos Voitures - Race Motors Group",
            description:
              "Découvrez notre collection exclusive de voitures de luxe et trouvez le véhicule de vos rêves dès aujourd'hui.",
          },
          carDetails: {
            metaDescription:
              "Découvrez les détails de {{carTitle}}, y compris les spécifications, la galerie et la brochure.",
          },
        },
        menu: {
          home: "Accueil",
          vehicles: "Nos véhicules",
          contact: "Contact",
          cars: "Voitures",
        },
        footer: {
          contactEmail: "contact@rmg.fr",
          copyrightName: "Race Motors Group",
          copyright: "Tous droits réservés",
          legal: "MENTIONS LEGALES",
          privacy: "POLITIQUE DE CONFIDENTIALITE",
          siteBy: "SITE PAR V.MARCONNET",
        },
        videoCarousel: {
          videos: [
            {
              title: "SAISON DES FÊTES",
              subject: "Collections",
              discoverText: "Découvrez les cadeaux",
            },
            {
              title: "ÉDITION LIMITÉE",
              subject: "Exclusivité",
              discoverText: "Découvrez l'édition limitée disponible maintenant",
            },
            {
              title: "NOUVELLE ARRIVÉE",
              subject: "Nouveautés",
              discoverText: "Découvrez les dernières nouveautés",
            },
          ],
        },
        cars: {
          title: "Nos Voitures",
          description: "Parcourez notre collection exclusive de voitures.",
          year: "Année",
          power: "Puissance",
          price: "Prix",
          noCars: "Aucune voiture trouvée. Veuillez réessayer plus tard.",
        },
        carDetails: {
          notFound: "Voiture non trouvée!",
          back: "Retour",
          price: "Prix",
          year: "Année",
          power: "Puissance",
          specification: "Spécification",
          details: "Détails",
          driveType: "Type de conduite",
          engine: "Moteur",
          transmission: "Transmission",
          maxTorque: "Couple maximal",
          topSpeed: "Vitesse maximale",
          acceleration: "Accélération",
          exteriorColor: "Couleur extérieure",
          interiorColor: "Couleur intérieure",
          photoGallery: "Galerie photo",
          video: "Vidéo",
          carSoundImmersion: "Plongez dans l'expérience sonore !",
          carSoundTip:
            "Mettez vos écouteurs et ressentez la puissance de ce moteur.",
          discoverButton: "Découvrir",
          interestButton: "Intéressé ?",
        },
        instagram: {
          followUs: "SUIVEZ-NOUS SUR ",
        },
        contactForm: {
          title: "Contactez-nous",
          name: "Nom",
          namePlaceholder: "Votre nom",
          email: "E-mail",
          emailPlaceholder: "Votre e-mail",
          message: "Message",
          messagePlaceholder: "Votre message",
          submit: "Envoyer",
          emailSuccess: "E-mail envoyé avec succès !",
          emailError: "Erreur lors de l'envoi de l'e-mail !",
          gender: {
            male: "Monsieur",
            female: "Madame",
          },
          firstName: "Prénom",
          firstNamePlaceholder: "Votre prénom",
          lastName: "Nom",
          lastNamePlaceholder: "Votre nom",
          region: "Région",
          regionPlaceholder: "Votre région",
        },
        showroom: {
          subTitle: "Race Motors Group / NOS VÉHICULES",
          title: "LE SHOWROOM RACE MOTORS GROUP",
          description1:
            "Découvrez un espace dédié aux voitures de luxe, de sport et d'exception, situé à une trentaine de minutes de Genève.",
          description2:
            "Notre équipe commerciale vous accueille exclusivement sur rendez-vous dans notre showroom afin de vous présenter une sélection de véhicules d'exception et de répondre à toutes vos demandes avec professionnalisme.",
          button: "SHOWROOM →",
        },
        services: {
          title: "LES SERVICES RMG",
          description:
            "Toutes les voitures de notre collection sont sélectionnées avec une extrême rigueur. Historique, garantie et configuration, nous ne laissons rien au hasard afin de vous donner accès à l’élite. Une exigence que nous appliquons également à toute la gamme de services proposés en complément. De la recherche personnalisée à la livraison par nos soins en passant par la conciergerie, nous mettons tout en œuvre pour que votre rêve se concrétise dans les meilleures conditions.",
          button: "EN SAVOIR PLUS →",
          imageAlt: "Voitures de luxe",
        },
        servicesSection: {
          saleTitle: "LA VENTE",
          saleDescription: "Les véhicules disponibles en showroom.",
          searchTitle: "LA RECHERCHE",
          searchDescription: "Trouvons ensemble la voiture de vos rêves.",
          exceptionTitle: "L'EXCEPTION",
          exceptionDescription: "Des raretés « off market » en accès exclusif.",
        },
        banner: {
          text: "POUR DES RAISONS DE <span class='bold'>SÉCURITÉ</span>, DE <span class='bold'>CONFIDENTIALITÉ</span> & DE QUALITÉ DE SERVICE, <span class='bold highlight'>L’ÉQUIPE VOUS ACCUEILLE UNIQUEMENT SUR RENDEZ-VOUS.</span>",
          contact: "CONTACTEZ-NOUS →",
        },
        newArrival: {
          title: "LES NOUVELLES VENUES",
          subtitle: "DÉCOUVREZ LES DERNIÈRES NOUVEAUTÉS DE NOTRE COLLECTION",
        },
      },
    },

    de: {
      translation: {
        helmet: {
          home: {
            title: "Startseite - Race Motors Group",
            description: "Entdecken Sie unsere Luxusautos in Schweiz.",
          },
          contact: {
            title: "Kontaktieren Sie uns - Race Motors Group",
            description:
              "Kontaktieren Sie Race Motors Group für Anfragen oder Informationen zu unseren Luxusautos.",
          },
          cars: {
            title: "Unsere Autos - Race Motors Group",
            description:
              "Entdecken Sie unsere exklusive Sammlung von Luxusautos und finden Sie noch heute Ihr Traumfahrzeug.",
          },
          carDetails: {
            metaDescription:
              "Entdecken Sie die Details von {{carTitle}}, einschließlich Spezifikationen, Galerie und Broschüre.",
          },
        },
        menu: {
          home: "Startseite",
          vehicles: "Unsere Fahrzeuge",
          contact: "Kontakt",
          cars: "Autos",
        },
        footer: {
          contactEmail: "kontakt@rmg.de",
          copyrightName: "Race Motors Group",
          copyright: "Alle Rechte vorbehalten",
          legal: "IMPRESSUM",
          privacy: "DATENSCHUTZERKLÄRUNG",
          siteBy: "SEITE VON V.MARCONNET",
        },
        videoCarousel: {
          videos: [
            {
              title: "FEIERTAGSSAISON",
              subject: "Kollektionen",
              discoverText: "Entdecken Sie Geschenke",
            },
            {
              title: "LIMITIERTE AUFLAGE",
              subject: "Exklusivität",
              discoverText: "Entdecken Sie die limitierte Auflage jetzt",
            },
            {
              title: "NEUE ANKUNFT",
              subject: "Neuheiten",
              discoverText: "Entdecken Sie die neuesten Neuheiten",
            },
          ],
        },
        cars: {
          title: "Unsere Autos",
          description: "Durchsuchen Sie unsere exklusive Autosammlung.",
          year: "Jahr",
          power: "Leistung",
          price: "Preis",
          noCars:
            "Keine Autos gefunden. Bitte versuchen Sie es später erneut..",
        },
        carDetails: {
          notFound: "Auto nicht gefunden!",
          back: "Zurück",
          price: "Preis",
          year: "Jahr",
          power: "Leistung",
          specification: "Spezifikation",
          details: "Details",
          driveType: "Antriebsart",
          engine: "Motor",
          transmission: "Getriebe",
          maxTorque: "Maximales Drehmoment",
          topSpeed: "Höchstgeschwindigkeit",
          acceleration: "Beschleunigung",
          exteriorColor: "Außenfarbe",
          interiorColor: "Innenfarbe",
          photoGallery: "Fotogalerie",
          video: "Video",
          carSoundImmersion: "Plongez dans l'expérience sonore !",
          carSoundTip:
            "Setzen Sie Ihre Kopfhörer auf und spüren Sie die Kraft dieses Motors.",
          discoverButton: "Entdecken",
          interestButton: "Interessiert ?",
        },
        instagram: {
          followUs: "FOLGEN SIE UNS AUF ",
        },
        contactForm: {
          title: "Kontakt",
          name: "Name",
          namePlaceholder: "Ihr Name",
          email: "E-Mail",
          emailPlaceholder: "Ihre E-Mail",
          message: "Nachricht",
          messagePlaceholder: "Ihre Nachricht",
          submit: "Senden",
          emailSuccess: "E-Mail erfolgreich gesendet!",
          emailError: "Fehler beim Senden der E-Mail!",
          gender: {
            male: "Herr",
            female: "Frau",
          },
          firstName: "Vorname",
          firstNamePlaceholder: "Ihr Vorname",
          lastName: "Nachname",
          lastNamePlaceholder: "Ihr Nachname",
          region: "Region",
          regionPlaceholder: "Ihre Region",
        },
        showroom: {
          subTitle: "Race Motors Group / UNSERE FAHRZEUGE",
          title: "DAS SHOWROOM VON RACE MOTORS GROUP",
          description1:
            "Entdecken Sie einen Raum, der Luxus-, Sport- und außergewöhnlichen Autos gewidmet ist, etwa dreißig Minuten von Genf entfernt.",
          description2:
            "Unser Verkaufsteam empfängt Sie ausschließlich nach Terminvereinbarung in unserem Showroom, um Ihnen eine Auswahl an außergewöhnlichen Fahrzeugen zu präsentieren und all Ihre Anfragen professionell zu beantworten.",
          button: "SHOWROOM →",
        },
        services: {
          title: "RMG-DIENSTLEISTUNGEN",
          description:
            "Alle Fahrzeuge in unserer Kollektion werden mit äußerster Sorgfalt ausgewählt. Geschichte, Garantie und Konfiguration – wir überlassen nichts dem Zufall, um Ihnen Zugang zur Elite zu gewähren. Diese gleiche Anforderung gilt für unser gesamtes Angebot an ergänzenden Dienstleistungen. Von der individuellen Suche bis zur Lieferung durch unser Team, einschließlich Concierge-Services, tun wir alles, um Ihren Traum unter den bestmöglichen Bedingungen zu verwirklichen.",
          button: "MEHR ERFAHREN →",
          imageAlt: "Luxusautos",
        },
        servicesSection: {
          saleTitle: "VERKAUF",
          saleDescription: "Fahrzeuge im Showroom verfügbar.",
          searchTitle: "SUCHE",
          searchDescription: "Lassen Sie uns gemeinsam Ihr Traumauto finden.",
          exceptionTitle: "AUSNAHME",
          exceptionDescription:
            "Seltene 'Off-Market'-Fahrzeuge mit exklusivem Zugang.",
        },
        banner: {
          text: "AUS SICHERHEITS-, <span class='bold'>VERTRAULICHKEITS</span>- UND DIENSTLEISTUNGSQUALITÄTSGRÜNDEN <span class='bold highlight'>EMPFÄNGT SIE UNSER TEAM NUR NACH VEREINBARUNG.</span>",
          contact: "KONTAKTIEREN SIE UNS →",
        },
        newArrival: {
          title: "NEUE ANKÜNFTE",
          subtitle: "ENTDECKEN SIE DIE NEUESTEN ZUGÄNGE ZU UNSERER KOLLEKTION",
        },
      },
    },
  },
  lng: "en", // Langue par défaut
  fallbackLng: "en", // Langue de secours
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
